///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { KbInputBaseComponent } from './../input.base.component';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'kb-boolean-radio-button-list',
    templateUrl: './boolean-radio-button-list.component.html',
})
export class KbBooleanRadioButtonListComponent extends KbInputBaseComponent {
    @ViewChild('trueRadioButton')
    public trueRadioButton: ElementRef;
    @ViewChild('falseRadioButton')
    public falseRadioButton: ElementRef;

    @Output()
    public modelChange: EventEmitter<boolean> = new EventEmitter();

    set model(value: boolean) {
        super.setModel<boolean>(value);
    }

    @Input()
    get model(): boolean {
        return super.getModel<boolean>();
    }

    public changeHandler(event: any): void {
        const fg: FormGroup = <FormGroup>this.viewFormArray.controls.find(c => (<FormGroup>c).controls[this.id] !== undefined);
        const { value } = fg.controls[this.id];
        super.updateModel<boolean>(value);
    }

    public shouldValidateComponent(): boolean {
        return false;
    }

    public getFirstInputId(): string {
        return `${this.id}_1`;
    }

    public getSecondInputId(): string {
        return `${this.id}_2`;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/boolean-radio-button-list/boolean-radio-button-list.component.ts